import { ViewModel, View } from "binder";
import { ColumnFilter } from "../columnFilter";
import  { StringFilterView } from "./stringFilter-view"

export class StringFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel, makeUpperCase:boolean) {
        super(parentViewModel);
        this.makeUpperCase = makeUpperCase;
    }
    GetDefaultView(): View <ViewModel> {
        return new StringFilterView();
    }
    public getTypeId(): string {
        return "VM-3754F560-9830-4C13-A2D4-F02682C56AEE"
    }

    public set makeUpperCase(v: boolean) { this._makeUpperCase = v; } public get makeUpperCase(): boolean { return this._makeUpperCase;} private _makeUpperCase: boolean;
    public set containsValue(v: string) { 
        if (this.makeUpperCase){
            v = v.toUpperCase();
        }
        this._containsValue = v; 
    } public get containsValue(): string { return this._containsValue;} private _containsValue: string;
    
}
